export const COMPANY_ROUTES = {
  BASE: 'company/*',
  LIST_COMPANY: {
    LINK: 'company/',
    PATH: '',
  },
  NEW_COMPANY: {
    LINK: 'company/new',
    PATH: 'new',
  },
};

export const ROUTES = {
  HOME: '/*',
  LOGIN: {
    BASE: 'login',
  },
  TEST_TARGET: {
    BASE: 'MasterData/TestTarget/*',
    ADD_TEST_TARGET: {
      BASE: 'MasterData/TestTarget/add',
    },
    EDIT_TEST_TARGET: {
      BASE: 'MasterData/TestTarget/edit/:TestTargetID',
    },
  },
  WORK_ORDER: {
    BASE: 'Work/WorkOrder/*',
    ADD_WORK_ORDER: {
      BASE: 'Work/WorkOrder/add',
    },
    ADD_SERIAL: {
      BASE: 'Work/WorkOrder/Serial/WorkOrderId=:workOrderId',
    },
    WORK_ORDER_DETAIL: {
      BASE: 'Work/WorkOrder/Detail/:workOrderId',
    },
    // báo cáo kế hoạch sản xuất
    REPORT_PRODUCTION_PLANNING: {
      BASE: "Work/ReportProductionPlanning"
    }
  },
  REPORTS: {
    BASE: 'Reports/*',
    MACHINE_STATUS: {
      LINK: '/Reports/BCTinhTrangMayMoc',
      SUB_LINK: '/Reports/BCTinhTrangMayMoc/Diagram',
    },
    REPORT_KHSX: {
      LINK: '/Reports/BCKeHoachSanXuat',
      DETAILS_LINK: '/Reports/BCKeHoachSanXuat/Details',
      BYID_LINK: '/Reports/BCKeHoachSanXuat/Details/:id',
    },
    REPORT_SLNS: {
      LINK: '/Reports/BCSanLuongNangSuat',
      SUB_LINK: '/Reports/BCSanLuongNangSuat/PivotTable',
    },
    // BC11
    REPORT_MARKETING: {
      LINK: '/Reports/BCKiemTraCongDoan',
      REPORT_MARKETING_DETAIL: {
        LINK: '/Reports/BCKiemTraCongDoan/Detail/WorkOrderCode=:woCode&StepCode=:stepCode',
      },
    },
    REPORT_STUCKWARNING: {
      LINK: '/Reports/BCCanhBaoTienDoDonHang',
    },
    REPORT_TGHDoMCSX: {
      LINK: '/Reports/BCTongHopTGHD',
    },
    REPORT_TGSX: {
      LINK: '/Reports/BCTGSX',
    },
    REPORT_TGMMGAPSUCO: {
      LINK: '/Reports/BCTGMayMocGapSuCo',
    },
    REPORT_HDSXCUAMAYMOC: {
      LINK: '/Reports/BCHoatDongSXCuaMCSX',
    },
    REPORT_TILEHTTUNGCONGDOAN: {
      LINK: '/Reports/BCTiLeHTCD',
    },
    REPORT_LSXHT: {
      LINK: '/Reports/BCLSXHoanThanh',
    },
  },
  PRODUCT: {
    BASE: 'Sale/Product/*',
    PRODUCT_DETAIL: {
      BASE: 'Sale/Product/productId=:productId',
    },
    EDIT_PRODUCT: {
      BASE: 'Sale/Product/Edit/productId=:productId',
    },
  },
  PRODUCT_ROUTING: {
    BASE: 'MES/LookUpProductionStage/*',
  },
  MATCH_CARD_COMMAND: {
    BASE: 'Work/MassWorkOrder/*',
    MATCH_CARD_COMMAND_DETAIL: {
      BASE: 'Work/MassWorkOrder/matchCardCommandId=:matchCardCommandId',
    },
  },

  STYLE_CATEGORY: {
    BASE: 'Sale/StyleCategory/*',
  },
  // Thực thi sản xuất
  // Lịch sử nhập kho
  HISTORY_RECEIVE: {
    BASE: 'MES/HistoryReceive',
    HISTORY_RECEIVE_DETAIL: {
      BASE: 'MES/HistoryReceive/:ReceiveId',
    },
  },
  // Nhập kho khuôn
  STOCKRECEIVING: {
    BASE: 'WareHouse/StockReceiving',
    ADD_STOCKRECEIVING: {
      BASE: 'Warehouse/StockReceiving/Create',
    },
    STOCKRECEIVING_DETAIL: {
      BASE: 'Warehouse/StockReceiving/Detail/:stockReceivingId',
    },
  },
  // Dư liệu nền
  MASTER_DATA: {
    BASE: 'MasterData/*',
    // Loại danh mục
    CATALOG: {
      LINK: 'MasterData/CatalogType',
      CREATE: 'MasterData/CatalogType/Create',
    },
    // Danh mục công đoạn/chuyền
    ROUTING_TRANSFER: {
      LINK: 'MasterData/Routing',
      CREATE: 'MasterData/Routing/Create',
      EDIT: 'MasterData/Routing/Edit/:id',
    },
  },
};
